import { createContext, useContext } from 'react';

/**
 * @typedef {Object} ChatContextType
 * @property {string|null} sessionId - Current chat session ID
 * @property {Array<Object>} messages - Array of chat messages
 * @property {boolean} isLoading - Whether chat is loading
 * @property {string|null} error - Current error message
 * @property {Function} sendMessage - Function to send a new message
 * @property {Function} handleNewChat - Function to start a new chat
 * @property {Function} setError - Function to set error state
 */

/** @type {React.Context<ChatContextType>} */
export const ChatContext = createContext();

/**
 * Hook to access chat session context
 * @returns {ChatContextType}
 */
export const useChatSession = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatSession must be used within a ChatProvider');
  }
  return context;
}; 